import { render } from "./kefuOrgList.vue?vue&type=template&id=34462628&scoped=true"
import script from "./kefuOrgList.vue?vue&type=script&lang=js"
export * from "./kefuOrgList.vue?vue&type=script&lang=js"

import "./kefuOrgList.vue?vue&type=style&index=0&id=34462628&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34462628"]])

export default __exports__